import {
  DefaultMenuItem,
  GetContextMenuItemsParams,
  MenuItemDef,
} from 'ag-grid-community'
import { UserApiTokenRow } from '../UserApiTokenRow'
import { intl } from '../../../../i18n'
import {
  ContextMenuItemId,
  getMenuIconHtml,
} from '../../../containers/commons/AgGrid/lib/contextMenu'

type RevokeHandler = (row: UserApiTokenRow) => void

export const createGetContextMenuItems =
  (onRevoke: RevokeHandler) =>
  (
    params: GetContextMenuItemsParams<UserApiTokenRow>
  ): (DefaultMenuItem | MenuItemDef)[] => {
    const { data } = params.node ?? {}
    if (!data || data.revoked) {
      return []
    }

    return [
      {
        name: intl.formatMessage({
          id: 'userApiToken.contextMenu.revoke',
        }),
        icon: getMenuIconHtml(ContextMenuItemId.REMOVE_ROW),
        action: () => onRevoke(data),
      },
    ]
  }
